export default __webpack_public_path__ + "static/media/img-about-banner-new-mobile-min.0294414c.png";